import React from 'react';
import Herosection from '../components/hero-section';
import ServiceOffer from '../components/Service-offer';
import Company from '../components/company';
import Review from '../components/Review';
import CaseStudy from '../components/caseStudy';
import Build from '../components/Build';
import Development from '../components/development';
import Tech from '../components/Tech';
import Alcaline from '../components/alcalinework';
import Leads from '../components/Lead';
import usePageMeta from '../hooks/usePageMeta';
const Home = () => {
    usePageMeta(
        'Spinnennetz — AI-Assisted CRO & Web Design Agency for eCommerce',
        'Spinnennetz is an AI-assisted CRO agency helping eCommerce brands boost conversion rates with custom landing pages, A/B testing sprints, and Shopify/WooCommerce development.',
        '/',
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Spinnennetz",
            "alternateName": "The Spinnennetz",
            "url": "https://thespinnennetz.com",
            "logo": "https://thespinnennetz.com/spinnennetz-logo.png",
            "description": "Spinnennetz is an AI-assisted CRO agency helping eCommerce brands boost conversion rates with landing pages, A/B testing sprints, and Shopify/WooCommerce development.",
            "sameAs": [
                "https://www.linkedin.com/company/spinnennetz/",
                "https://www.facebook.com/profile.php?id=61558451699367"
            ],
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-99797-30979",
                "contactType": "customer service",
                "email": "info@thespinnennetz.com",
                "availableLanguage": "English"
            }
        },
        'spinnennetz, Spinnennetz agency, AI CRO agency, eCommerce CRO, conversion rate optimization, Shopify CRO, web design agency'
    );
    return (
        <>
            {/* <img src={require('../asstes/bootstrap.svg').default} /> */}
            <Herosection />
            <ServiceOffer />
            <Company />
            <Review />
            <CaseStudy />
            <Build />
            <Development />
            <Tech />
            <Alcaline />
            <Leads />
        </>
    )
}

export default Home;
